'use client';

import { useCallback } from 'react';
import { hapticFeedback } from '@telegram-apps/sdk';

type ImpactStyle = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';
type NotificationType = 'error' | 'success' | 'warning';

export const useHaptic = () => {
  const impact = useCallback((style: ImpactStyle = 'medium') => {
    try {
      if (hapticFeedback.isSupported()) {
        hapticFeedback.impactOccurred(style);
      }
    } catch (error) {
      console.warn('Haptic feedback error:', error);
    }
  }, []);

  const notification = useCallback((type: NotificationType) => {
    try {
      if (hapticFeedback.isSupported()) {
        hapticFeedback.notificationOccurred(type);
      }
    } catch (error) {
      console.warn('Haptic feedback error:', error);
    }
  }, []);

  const selectionChanged = useCallback(() => {
    try {
      if (hapticFeedback.isSupported()) {
        hapticFeedback.selectionChanged();
      }
    } catch (error) {
      console.warn('Haptic feedback error:', error);
    }
  }, []);

  return {
    impact,
    notification,
    selectionChanged,
  };
};
